import { api } from "../../services";
import { $config } from "../../conf";
import $store from "../../store";

export let formAPI = {
   /**
   * 获取某个栏目下的栏目列表,包含子级栏目
   * @param globalUserId  globalUserId
   * @param id  id
   */
  acquireFormAPI({globalUserId,id,tenantId,customFormId}) {
    return  api.request("/api/customform/get", {
      globalUserId,
      id,
      tenantId,
      customFormId
    })
  },
  /**
   * 获取表单静态参数
   * @param type  customForm
   * @param id  2304032617136416
   */
  getJsonParamsInfo({type,id,globalUserId}) {
    return  api.request("/api/common/jsonParams/get", {
      type,
      id,
      globalUserId,
    })
  },
  /**
   * 获取表单模板信息
   * @param configId  configId
   * @param globalUserId  2304032617136416
   * @param tenantId  租户id
   */
  getFormConfig({configId,globalUserId,tenantId}) {
    return  api.request("/template/template/getConfig", {
      configId,
      globalUserId,
      tenantId,
    })
  },  /**
   * 获取表单模板信息
   * @param type  customForm
   * @param id  2304032617136416
   */
  checkRegistration({customFormId,globalUserId,instanceId,openId,tenantId}) {
    return  api.request("/customForm/checkRegistration", {
      customFormId,
      globalUserId,
      instanceId,
      openId,
      tenantId,
    })
  },
  /**
   * 获取view
   * @param type  customForm
   * @param id  2304032617136416
   */
  customFormView({customFormId,globalUserId,linkId,memberId,openId,referenceUrl,sess,tenantId,url,weChatId}) {
    return  api.request("/customForm/view", {
      customFormId,globalUserId,linkId,memberId,openId,referenceUrl,sess,tenantId,url,weChatId
    })
  },
  /**
   * 浏览
   * @param type  customForm
   * @param id  2304032617136416
   */
  customFormBrowse({customFormId,globalUserId,openId,sess,tenantId}) {
    return  api.request("/api/customform/browse", {
      customFormId,globalUserId,openId,sess,tenantId
    })
  },  /**
   * 浏览
   * @param type  customForm
   * @param id  2304032617136416
   */
  customFormAction(params) {
    return  api.request("/customForm/action", params)
  },


  /**
   * 发送验证码
   * @param params
   * @returns {*}
   */
  sendCode(params) {
    return api.request("/customForm/sendCheckCode", params)//api.request("/member/sendCheckCode", params)
  },
  /**
   * 验证验证码
   * @param params
   * @returns {*}
   */
    checkCode(params) {
    return  api.request("/member/checkCode", params)
  },
  /**
   * 公司模糊查询
   * @param params
   * @returns {*}
   */
  getCompanyQuery(params) {
    return  api.request("/api/company/query", params)
  },
  /**
   * 获取公司数据
   * @param params
   * @returns {*}
   */
  getCompanyData(params) {
    return  api.request("/api/company/get", params)
  },


}

